var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1557_2034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4009 22H11.9088C11.8468 21.9876 11.7855 21.9667 11.723 21.9634C9.78778 21.8666 7.90689 21.4909 6.06961 20.8812C5.91242 20.829 5.88389 20.7515 5.88389 20.6062C5.88712 16.8179 5.88712 13.0303 5.88281 9.24207C5.88281 9.09623 5.9318 9.00905 6.04377 8.92294C6.89539 8.26583 7.71471 7.57212 8.43337 6.76809C9.03413 6.09645 9.53961 5.36992 9.84807 4.51045C10.2007 3.52829 10.5829 2.55688 10.9656 1.58602C11.0722 1.31532 11.1966 1.04139 11.3661 0.807818C11.7984 0.213136 12.3916 -0.0823214 13.134 0.0199316C13.9118 0.127028 14.4701 0.537655 14.6719 1.31801C14.7807 1.73724 14.849 2.17478 14.8684 2.60693C14.9303 3.96744 14.6989 5.30264 14.4631 6.63516C14.3985 6.99897 14.3199 7.35954 14.2418 7.75133C14.3473 7.75133 14.4238 7.75133 14.5008 7.75133C15.2819 7.75133 16.0624 7.74972 16.8435 7.75133C17.6241 7.75349 18.4068 7.72712 19.1852 7.77071C20.7216 7.85682 21.7051 9.44658 21.1269 10.869C21.0655 11.0197 20.9859 11.1628 20.9116 11.3157C21.6109 11.779 21.9985 12.4243 21.999 13.2574C21.9995 14.0975 21.6023 14.7454 20.9073 15.205C21.6426 16.367 21.304 17.8507 20.0341 18.5449C20.061 18.6009 20.0869 18.658 20.1154 18.7139C20.5929 19.6536 20.3458 20.7988 19.5319 21.4726C19.1981 21.7492 18.8089 21.8913 18.4003 21.9989L18.4009 22Z",
    fill: "#7B68EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000438244 10.1823C0.152983 9.79208 0.438291 9.65269 0.85495 9.65915C2.00749 9.67637 3.16003 9.66507 4.31257 9.66507C4.39116 9.66507 4.46922 9.66507 4.56612 9.66507V20.5292H4.31203C3.15949 20.5292 2.00641 20.5211 0.853873 20.5335C0.431293 20.5378 0.13145 20.4006 -0.000976562 19.9802V10.1823H-0.000438244Z",
    fill: "#7B68EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1557_2034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon01);
export default __webpack_public_path__ + "static/media/like-icon-01.32681050ea4b224d229825fd7db288e2.svg";
export { ForwardRef as ReactComponent };